import axios from "axios";
import { ClientVarsResponse, DiscountCode, TrustedReseller } from "@/api/types";

export const getClientVars = () => axios.get<ClientVarsResponse>('/manage/vars');
export const setClientVars = (vars: ClientVarsResponse) => axios.post('/manage/vars', { vars });
export const setEnv = (key: string, value: string) => axios.post('/manage/env', { key, value });
export const getDiscountCodes = () => axios.get<DiscountCode[]>('/manage/discounts')
export const setDiscountCodes = (codes: DiscountCode[]) => axios.post('/manage/discounts', { codes })
export const getTrustedResellers = () => axios.get<TrustedReseller[]>('/manage/trusted-resellers')
export const setTrustedResellers = (resellers: TrustedReseller[]) =>
    axios.post('/manage/trusted-resellers', { resellers })
